import React from 'react';
import { FiLock } from 'react-icons/fi';
import imgLogo from '~/assets/img/logo.png';
import { formatarData, formatarDataHora } from '~/config/encerramentoSistema';
import CartaoContato from './CartaoContato';
import {
  BotaoSecundario,
  CartaoEncerrado,
  ContainerTelaEncerrada,
  IconeCadeado,
} from './styles';

interface TelaAcessoEncerradoProps {
  ultimoDiaDeAcesso: string;
  /** Fim da liberação temporária, quando ela já terminou. */
  fimLiberacao?: number;
}

const TelaAcessoEncerrado: React.FC<TelaAcessoEncerradoProps> = ({
  ultimoDiaDeAcesso,
  fimLiberacao,
}) => (
  <ContainerTelaEncerrada>
    <CartaoEncerrado>
      <img src={imgLogo} alt="Konvix" className="logo" />
      <div>
        <IconeCadeado>
          <FiLock size={28} aria-hidden />
        </IconeCadeado>
      </div>
      <h1>Acesso encerrado</h1>
      <p>
        O período de acesso a este sistema terminou em{' '}
        <strong>
          {fimLiberacao === undefined
            ? formatarData(ultimoDiaDeAcesso)
            : formatarDataHora(fimLiberacao)}
        </strong>
        .
      </p>
      <p>
        Agradecemos imensamente pela confiança e pela parceria ao longo de todo
        esse período.
      </p>

      <CartaoContato />

      <BotaoSecundario type="button" onClick={() => window.location.reload()}>
        Tentar novamente
      </BotaoSecundario>
    </CartaoEncerrado>
  </ContainerTelaEncerrada>
);

export default TelaAcessoEncerrado;
